module.exports = __webpack_public_path__ + "static/Corprate_WhoWeAre_01-2201fbeaf17cccc133f9cf051e53fa3b.jpg";